module.exports = '<svg width="64" height="32" viewBox="0 0 64 32"><path d="M60 20h-8v-8h8c2.212 0 4-1.788 4-4s-1.788-4-4-4h-8c0-2.212-1.788-4-4-4H32c-2.212 0-4 1.788-4 4H4C1.788 4 0 5.788 0 8v16c0 2.212 1.788 4 4 4h24c0 2.212 1.788 4 4 4h16c2.212 0 4-1.788 4-4h8c2.212 0 4-1.788 4-4s-1.788-4-4-4zM8 20v-8h20v8H8z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/battery-charging-2.js
// module id = 999
// module chunks = 14